import ProTreeNode from "@/components/login-unit/pro-tree-node.vue";
export default {
  name: "Tree",
  components: {
    ProTreeNode
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    favoriteUnitIds: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};